<template>
  <div class="login-page">
<!--    <div class="web-name">-->
<!--      <img src="../assets/liantong.png" class="logoImg">-->
<!--      <img src="../assets/5G.png" class="logoImg2">-->
<!--    </div>-->
    <div class="login-banner">
      <div class="login-banner-main">
        <div class="demo-input-suffix-box">

          <div style="display: flex;justify-content: center;font-size: 16px;line-height: 36px;margin-bottom: 20px;">
            <div :class="!loginByWx ? 'login-top-title-active' : 'login-top-title'" @click="loginByWx = false">账密登录</div>
<!--            <div :class="loginByWx ? 'login-top-title-active' : 'login-top-title'" @click="loginByWx = true">扫码登录</div>-->
          </div>

          <!--<div class="changeBtn">-->
            <!--<div class="changeBtnMask"></div>-->
            <!--<i class="iconfont el-icon-damai-diannao" @click="loginByWx = false" v-if="loginByWx"></i>-->
            <!--<i class="iconfont el-icon-damai-erweima" @click="loginByWx = true" v-if="!loginByWx"></i>-->
          <!--</div>-->
          <wx-login v-if="loginByWx" :appid="wxConfig.appid" :scope="wxConfig.scope" :redirect_uri="wxConfig.redirect_uri" :theme="wxConfig.theme" :href="wxConfig.href" class="wx-login-box" />
          <div v-if="loginByWx" style="position: absolute;bottom: 55px;">请使用微信扫码登录</div>
          <ul class="demo-input-suffix" v-if="!loginByWx">
            <!--<li>用户登录</li>-->
            <li id="company">
              <el-input placeholder="园区名称" prefix-icon="el-icon-damai-yuanqu" v-model="yqCode" size="mini" />
            </li>
            <li id="user">
              <el-input placeholder="用户名" prefix-icon="el-icon-damai-yonghu" v-model="name" size="mini" />
            </li>

            <li id="password">
              <el-input placeholder="密码" prefix-icon="el-icon-damai-weibaoxitongshangchuanlogo" v-model="password" type="password" size="mini" @keyup.enter.native="login" />
            </li>
            <li id="pswforget">
              <span @click="TopswForget">忘记密码？</span>
            </li>
            <li id="youcode">
              <el-input placeholder="验证码" prefix-icon="el-icon-damai-yanzhengma" v-model="identityCode" :maxlength=4 class="code" size="mini" @keyup.13.native="login" />
              <img :src="codeImg" alt="验证码" class="codeImg" @click="getIdentityCode">
            </li>
            <li id="prompt">
              <b v-html="promotPro"></b>
            </li>

            <li id="loginBtn">
              <a @click="login">登录</a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!--<footer class="login_footer">-->
      <!--<span style="display:inline-block;text-decoration:none;height:40px;line-height:40px;">Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</span>-->
    <!--</footer>-->
  </div>

</template>

<script>
  /* eslint-disable */
  import md5 from 'js-md5'
  import bus from '../utils/bus'
  import {pattern} from '../utils/regular'
  import {errorHandler} from '../utils/errorHandler'
  import {errorMessage} from '../utils/errorCode'
  import {api} from './api/Login'
  import wxLogin from 'vue-wxlogin'

  export default {
    name: 'login-zjrob',
    components: {
      wxLogin
    },
    data () {
      return {
        loginByWx: false,
        wxConfig: {
          appid: 'wx8910f30473aa9e86',
          scope: 'snsapi_login',
          redirect_uri: 'https://yq.damaiiot.com/wx_login_bind_account',
          state: '',
          theme: 'white',
          href: 'https://yq.damaiiot.com/yq/test/css/wxLogin.css',
        },
        yqCode: '',
        name: '',
        password: '',
        identityCode : '',
        promotPro: '',
        codeImg: '',
        randomStr: ''
      }
    },
    created: function () {
      this.getIdentityCode()
    },
    methods: {
      TopswForget: function () {
        this.$router.push({
          name: 'resetPassword'
        })
      },
      toHomepage () {
        window.sessionStorage.setItem('navTop', 'workbench')
        this.$router.push({
          name: 'workbench'
        })
      },
      toyqInfoPage () {
        let routerName = ''
        window.sessionStorage.setItem('navTop', 'resource')
        if (bus.global.permissionCodes.indexOf('001001000') !== -1) {
          routerName = 'yq-information'
        } else if (bus.global.permissionCodes.indexOf('001002000') !== -1) {
          routerName = 'yq-notice-management'
        } else if (bus.global.permissionCodes.indexOf('001002004') !== -1) {
          routerName = 'yq-video-management'
        } else if (bus.global.permissionCodes.indexOf('001003000') !== -1) {
          routerName = 'housing-management'
        } else if (bus.global.permissionCodes.indexOf('001004000') !== -1) {
          routerName = 'business-management'
        } else if (bus.global.permissionCodes.indexOf('001005000') !== -1) {
          routerName = 'person-management'
        } else if (bus.global.permissionCodes.indexOf('001006000') !== -1) {
          routerName = 'config-card'
        } else if (bus.global.permissionCodes.indexOf('001007000') !== -1) {
          routerName = 'account-management'
        } else if (bus.global.permissionCodes.indexOf('001008000') !== -1) {
          routerName = 'role-management'
        } else if (bus.global.permissionCodes.indexOf('001009000') !== -1) {
          routerName = 'ali-config'
        } else if (bus.global.permissionCodes.indexOf('001009004') !== -1) {
          routerName = 'config-routine'
        } else if (bus.global.permissionCodes.indexOf('001009006') !== -1) {
          routerName = 'config-card-type'
        } else if (bus.global.permissionCodes.indexOf('001010000') !== -1) {
          routerName = 'resource-center-log'
        } else if (bus.global.permissionCodes.indexOf('002001000') !== -1) {
          routerName = 'custom-management'
        } else if (bus.global.permissionCodes.indexOf('003001000') !== -1) {
          routerName = 'accessCtrlDeviceManagementCenter'
        } else if (bus.global.permissionCodes.indexOf('004001000') !== -1) {
          routerName = 'parking-device-management'
        } else if (bus.global.permissionCodes.indexOf('005001000') !== -1) {
          routerName = 'controller-management'
        } else if (bus.global.permissionCodes.indexOf('007004000') !== -1) {
          routerName = 'visitor-device-manage'
        } else if (bus.global.permissionCodes.indexOf('008001000') !== -1) {
          routerName = 'site-management'
        } else if (bus.global.permissionCodes.indexOf('009001000') !== -1) {
          routerName = 'ladder-device'
        } else if (bus.global.permissionCodes.indexOf('011001000') !== -1) {
          routerName = 'repair-category-manage'
        } else if (bus.global.permissionCodes.indexOf('002007000') !== -1) {
          routerName = 'needHandle'
        } else {
          routerName = 'workbench'
        }
        this.$router.push({
          name: routerName
        })
      },
      getIdentityCode () {
        let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
        let pwd = ''
        for (let i = 0; i < 4; i++) {
          let id = Math.ceil(Math.random()*35)
          pwd += chars[id]
        }
        this.randomStr = pwd
        this.$axios.get(`${api.getIdentityCode}/${this.randomStr}`, {})
          .then(res => {
            this.codeImg = res.data.data
          })
          .catch(errorHandler('获取验证码失败'))
      },
      login () {
        const atn = pattern.accountName
        const psd = pattern.password
        if (!this.yqCode) {
          this.promotPro = '<b>请输入园区名称</b>'
          return false
        }
        if (!this.name) {
          this.promotPro = '<b>请输入用户名</b>'
          return false
        }else if (!atn.test(this.name)) {
          this.promotPro = '<b>请输入正确的用户名格式</b>'
          return false
        }else {
          this.promotPro = ''
        }
        if (!this.password) {
          this.promotPro = '<b>请输入密码</b>'
          return false
        }else if (!psd.test(this.password)) {
          this.promotPro = '<b>请输入正确的密码格式</b>'
          return false
        } else {
          this.promotPro = ''
        }
        if (!this.identityCode) {
          this.promotPro = '<b>请输入验证码</b>'
          return false
        } else {
          this.promotPro = ''
        }
        let yqCode = this.yqCode.toLowerCase()
        this.promotPro = ''
        let name = this.name.toLowerCase()
        let pw = this.password + name
        let once = md5(pw) + name
        let pwd
        for (let i = 0; i < 9; i++) {
          pwd = md5(once)
          once = pwd + name
        }

        this.$axios.post(api.login, {
          name: name,
          password: pwd,
          identityCode: this.identityCode,
          yqAppCode: yqCode,
          randomStr: this.randomStr
        })
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              // if (res.data.data.buildingCode) {
              //   let buildingCode = res.data.data.buildingCode.join(',')
              //   window.sessionStorage.setItem('accountHasBuildingCode', buildingCode)
              //   bus.global.accountHasBuildingCode = buildingCode
              // }
              window.sessionStorage.setItem('accountCode', res.data.data.code)
              window.sessionStorage.setItem('accountName', res.data.data.name)
              window.sessionStorage.setItem('accountPersonCode', data.personCode)
              window.sessionStorage.setItem('accountPersonName', data.personName)
              window.sessionStorage.setItem('token', res.data.data.token)
              window.sessionStorage.setItem('permissionCodes', res.data.data.permissionCodes)
              window.sessionStorage.setItem('yqCode', yqCode)
              bus.global.accountCode = res.data.data.code
              bus.global.accountName = res.data.data.name
              bus.global.personCode = data.personCode
              bus.global.personName = data.personName
              bus.global.token = res.data.data.token
              bus.global.yqCode = yqCode
              bus.global.permissionCodes = res.data.data.permissionCodes
              // if (this.yqCode === 'ahdl') {
              //   bus.global.yqOrEngineer = '工程'
              // } else {
              //   bus.global.yqOrEngineer = '园区'
              // }
              if (data.isFirstTime === '1') {
                if (res.data.data.permissionCodes.indexOf('000000000') === -1) {
                  this.toyqInfoPage()
                } else {
                  this.toHomepage()
                }
              } else {
                window.sessionStorage.setItem('firstChangeOldPassword', pwd)
                this.$router.push({
                  name: 'first-change-password'
                })
              }
            }
          })
          .catch(e => {
            this.$layer.toast({
              icon: 'icon-check',
              content: errorMessage(+e.response.data.data),
              time: 1000
            })
            let chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
            let pwd = ''
            for (let i = 0; i < 4; i++) {
              let id = Math.ceil(Math.random()*35)
              pwd += chars[id]
            }
            this.randomStr = pwd
            this.$axios.get(`${api.getIdentityCode}/${this.randomStr}`, {})
              .then(res => {
                this.codeImg = res.data.data
              })
              .catch(errorHandler('获取验证码失败'))
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .head img {
    width: 250px;
    height: 44px;
    margin: 15px 10px 15px 30px;
  }

  .head b {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #000000;
  }
  .head span {
    font-size: 24px;
    font-family: STHeiti;
    font-weight: 600;
    color: #000000;
    line-height: 30px;
    vertical-align: middle;
    display: inline-block;
    padding: 0 10px;
  }
  .centen {
    width: 100%;
    height: 90%;
    background-color: #EFF1F5;
    position: relative;
  }


  footer {
    width: 100%;
    font-size: 13px;
    text-align: center;
    color: #999999;
    background-color: #F0F3F7;
    height: 50px;
    line-height: 35px;
  }

  a:hover {
    cursor: pointer;
  }

  .codeImg {
    display: inline-block;
    width: 100px;
    height: 28px;
    margin-left: 10px;
    vertical-align: bottom;
  }

  .codeImg:hover {
    cursor: pointer;
  }

  #prompt {
    line-height: 16px;
    padding: 0;
    margin: 0;
  }

  #prompt b {
    display: block;
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 8px;
    margin-bottom: -5px;
  }

  #pswforget {
    margin: 0;
    padding: 0 33px;
    display: flex;
    justify-content: flex-end;
  }

  #pswforget span {
    margin: -5px;
    display: inline-block;
    color: #a6a6a6;
  }

  #pswforget span:hover {
    color: #00A0E6;
    cursor: pointer;
  }

  #youcode {
    margin: 0;
    display: flex;
    justify-content: space-between;
  }

</style>

<style lang="less" scoped>
  .login-page {
    height: 100vh;
    min-height: 600px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    background: url("../assets/hzjkdz.jpg") no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .web-name {
      font-size: 32px;
      line-height: 60px;
      text-align: left;
      padding: 20px 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logoImg {
        width: 80px;
        height: 80px;
      }
      .logoImg2 {
        width: 60px;
        height: 60px;
      }
    }
    .login-banner {
      margin-top: 120px;
      height: 360px;
      position: relative;
      .login-banner-img {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 360px;
        background-image: url('../assets/login.png');
        background-position: center center;
      }
      .login-banner-main {
        width: 80%;
        height: 220px;
        margin: 60px auto 0;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .banner-tip1 {
          color: #ffffff;
          font-size: 28px;
          text-align: left;
        }
        .banner-tip2 {
          margin-top: 10px;
          color: #ffffff;
          font-size: 18px;
          text-align: left;
        }
        .demo-input-suffix-box {
          width: 400px;
          height: 340px;
          /*position: absolute;*/
          /*top: 30px;*/
          /*right: 0;*/
          background: #99999999;
          /*border: 1px solid #E6E6E6;*/
          border-radius: 10px;
          position: relative;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          flex-direction: column;
          color: #ffffff;
          .login-top-title {
            cursor: pointer;
            margin: 0 20px;
            color: #eeeeee;
          }
          .login-top-title:hover {
            color: #5CCBFA;
          }
          .login-top-title-active {
            cursor: pointer;
            margin: 0 20px;
            color: #5CCBFA;
            border-bottom: 1px solid #5CCBFA;
          }
          .changeBtn {
            position: absolute;
            right: 0;
            top: 0;
            overflow: hidden;
            .changeBtnMask {
              position: absolute;
              left: 0;
              top: 0;
              width: 50px;
              height: 50px;
              background-color: #99999999;
              transform:rotate(45deg) translate(-10px, 26px);
              -ms-transform:rotate(45deg) translate(-10px, 26px);
              -moz-transform:rotate(45deg) translate(-10px, 26px);
              -webkit-transform:rotate(45deg) translate(-10px, 26px);
              -o-transform:rotate(45deg) translate(-10px, 26px);
            }
          }
          .el-icon-damai-diannao {
            cursor: pointer;
            font-size: 42px;
            color: #00a0e6;
          }
          .el-icon-damai-erweima {
            cursor: pointer;
            font-size: 42px;
            color: #00a0e6;
          }
        }
        .demo-input-suffix {
          width: 370px;
          height: 310px;
          /*position: absolute;*/
          /*top: 30px;*/
          /*right: 0;*/
          background: none;
          /*border: 1px solid #E6E6E6;*/
          border-radius: 5px;
        }

        .demo-input-suffix li {
          padding: 8px 33px;
        }

        /*.demo-input-suffix li:first-child {*/
          /*text-align: center;*/
          /*font-size: 20px;*/
          /*line-height: 30px;*/
          /*color: #ffffff;*/
        /*}*/

        .demo-input-suffix li:first-child {
          margin-bottom: 8px;
        }

        .wx-login-box {
          width: 300px;
          height: 260px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          transform:scale(0.7, 0.7);
          -ms-transform:scale(0.7, 0.7);
          -moz-transform:scale(0.7, 0.7);
          -webkit-transform:scale(0.7, 0.7);
          -o-transform:scale(0.7, 0.7);
        }

        #loginBtn a {
          display: block;
          color: white;
          background: #009FE5;
          text-align: center;
          line-height: 36px;
          font-size: 16px;
          border-radius: 15px;
        }

        .code {
          width: 180px;
        }
      }
    }
    .login-introduce {
      width: 1200px;
      height: 800px;
      margin: 20px auto 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }

    .login_footer {
      width: 100%;
      height: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/login-5.vue